export const SET_CONFIG = 'SET_CONFIG';

export function configReducer(state = {}, action) {
  switch (action.type) {
    case SET_CONFIG: return {...state, ...action.config}
    default: return state
  }
}
